import * as React from "react";
import { Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

interface BusinessReportOutcomeExportProps {
  businessReportOutcomeId: string;
}

export const BusinessReportOutcomeExport: React.FC<BusinessReportOutcomeExportProps> = ({
  businessReportOutcomeId,
}) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button variant="default" size="sm" className="ml-1 rounded bg-primary px-4 py-2 text-white">
        <Download className="mr-2 h-5 w-5" />
        Export
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem>
        <a
          href={`/pf-business-reports/business-report-outcome/export?business_report_outcome_id=${businessReportOutcomeId}&format=docx`}
        >
          Export to Word
        </a>
      </DropdownMenuItem>
      <DropdownMenuItem>
        <a
          href={`/pf-business-reports/business-report-outcome/export?business_report_outcome_id=${businessReportOutcomeId}&format=xlsx`}
        >
          Export to XLS
        </a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
